module.exports = "/_next/static/files/7b5ced9582e86154fbd9134dc451a146.png";